import React, { useState } from "react";
import { Menu, PanelTop, LayoutTemplate } from "lucide-react";
import CreditsBadge from "../CreditsBadge";
import NavDrawer from "./NavDrawer";

const VIEWS = [["build", PanelTop, "Build"], ["templates", LayoutTemplate, "Templates"]];

export const HomeTopBar = ({ view, setView }) => {
  const [open, setOpen] = useState(false);
  return (
    <header className="relative z-20 max-w-5xl mx-auto px-4 sm:px-6 pt-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <button onClick={() => setOpen(true)} data-testid="home-menu-button" aria-label="Open menu"
          className="w-12 h-12 rounded-full bg-white text-slate-900 flex items-center justify-center shadow-[0_6px_18px_-6px_rgba(15,23,42,0.25)] hover:scale-105 transition-transform">
          <Menu size={22} strokeWidth={2} />
        </button>
        <div className="flex items-center p-1 rounded-2xl bg-sky-900/10 backdrop-blur-md ring-1 ring-white/50" role="tablist" data-testid="home-view-toggle">
          {VIEWS.map(([id, Icon, label]) => (
            <button key={id} role="tab" aria-selected={view === id} onClick={() => setView(id)} data-testid={`home-view-${id}`} aria-label={label} title={label}
              className={`h-10 w-14 rounded-xl flex items-center justify-center transition-[background-color,box-shadow,color] ${view === id ? "bg-white text-slate-900 shadow-sm" : "text-slate-700 hover:bg-white/40"}`}>
              <Icon size={19} strokeWidth={1.9} />
            </button>
          ))}
        </div>
      </div>
      <CreditsBadge />
      <NavDrawer open={open} onOpenChange={setOpen} onTemplates={() => setView("templates")} />
    </header>
  );
};

export default HomeTopBar;
